/**
 * Returns a list with auxiliaries for the Dutch passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default [
	"word",
	"wordt",
	"worden",
	"werd",
	"werden",
	"wordend",
];

